// Path scheme for the public "Sign up your sport club" wizard. A single place
// builds and recognises `/signup` so the login screen's link and the
// client-side route resolver (`main.tsx`) always agree. Kept framework-free so
// it can be unit-tested in isolation, mirroring `clubSharePath.ts`.

import { COMPANY_SIGNUP_ROUTE } from '../../domain';

/** In-app path of the sign-up wizard, e.g. "/signup". */
export function signupPath(): string {
  return COMPANY_SIGNUP_ROUTE;
}

/**
 * Whether a pathname is the sign-up wizard route. Accepts optional trailing
 * slashes and nothing else — any extra segment falls through to the app.
 */
export function isSignupPath(pathname: string): boolean {
  return pathname.replace(/\/+$/, '') === COMPANY_SIGNUP_ROUTE;
}
